import { updateCart } from './update-cart'

const $win = $(window)
const $doc = $(document)

// Remove Elements From Cart
$doc.on('click', '.js-cart-remove', function (e) {
  e.preventDefault()
  const $this = $(this)
  const $form = $this.closest('form')
  const productId = parseInt($this.attr('href'))

  updateCart($form, true, productId)
})
